export const Radius: Radius = {
  insaneRadius: 48,
  hugeRadius: 40,
  giantRadius: 32,
  bigRadius: 26,
  largeRadius: 20,
  mediumRadius: 16,
  shortRadius: 12,
  smallRadius: 8,
  smallerRadius: 4,
  meaninglessRadius: 2,
};

export default Radius;
